// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.66-TSS-3069-mcastro-IMPROVEMENT-Hyperlink-from-URL.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
